import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './components/AdminLayout';
import { DashboardPage } from './pages/DashboardPage';
import { TherapistVerificationPage } from './pages/TherapistVerificationPage';
import { TherapistsPage } from './pages/TherapistsPage';
import { SessionsPage } from './pages/SessionsPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { TranslationsPage } from './pages/TranslationsPage';
import { ReportsPage } from './pages/ReportsPage';
import { ExpansionPage } from './pages/ExpansionPage';
import { PayoutsPage } from './pages/PayoutsPage';
import { CorporateApprovalsPage } from './pages/CorporateApprovalsPage';
import { CampusPartnershipsPage } from './pages/CampusPartnershipsPage';
import { HmoKeysPage } from './pages/HmoKeysPage';
import { MatchingBiasPage } from './pages/MatchingBiasPage';
import { ContentPage } from './pages/ContentPage';
import { WellnessPage } from './pages/WellnessPage';
import { EngagementPage } from './pages/EngagementPage';
import { WalletOpsPage } from './pages/WalletOpsPage';
import { LoginPage } from './pages/LoginPage';
import { UsersPage } from './pages/UsersPage';
import { StaffChatPage } from './pages/StaffChatPage';
import { DependencyVulnerabilitiesPage } from './pages/DependencyVulnerabilitiesPage';
import { BackupsPage } from './pages/BackupsPage';
import { WebSessionsPage } from './pages/WebSessionsPage';
import { VideoProviderPage } from './pages/VideoProviderPage';
import { useAdminAuth } from './hooks/useAdminAuth';

export default function AdminApp() {
  const { user, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-gray-500">Loading...</div>
    );
  }

  if (!user || user.role !== 'admin') {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="therapists" element={<TherapistsPage />} />
        <Route path="therapists/pending" element={<TherapistVerificationPage />} />
        <Route path="sessions" element={<SessionsPage />} />
        <Route path="audit-logs" element={<AuditLogPage />} />
        <Route path="translations" element={<TranslationsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="matching-bias" element={<MatchingBiasPage />} />
        <Route path="expansion" element={<ExpansionPage />} />
        <Route path="payouts" element={<PayoutsPage />} />
        <Route path="corporate" element={<CorporateApprovalsPage />} />
        <Route path="campus" element={<CampusPartnershipsPage />} />
        <Route path="hmo-keys" element={<HmoKeysPage />} />
        <Route path="content" element={<ContentPage />} />
        <Route path="wellness" element={<WellnessPage />} />
        <Route path="engagement" element={<EngagementPage />} />
        <Route path="wallet" element={<WalletOpsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="staff-chat" element={<StaffChatPage />} />
        <Route path="dependencies" element={<DependencyVulnerabilitiesPage />} />
        <Route path="backups" element={<BackupsPage />} />
        <Route path="web-sessions" element={<WebSessionsPage />} />
        <Route path="live-sessions" element={<VideoProviderPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
